$(() => {
    $('#group').on('change', () => {
        $('#vuzName').val('');
        $('#frmRanking').submit();
    });
    const metodologyContainer = $('#metodology');
    const btnShowMetodology = $('#btnShowMetodology');
    btnShowMetodology.on('click', () => {
        if (metodologyContainer.is(':visible')) {
            metodologyContainer.slideUp();
            btnShowMetodology.html('Показать методологию');
        } else {
            metodologyContainer.slideDown();
            btnShowMetodology.html('Скрыть методологию');
        }
    });
    $('#ooType').on('change', function () {
        const value = $(this).val();
        if (value == 1) {
            location.replace('/ranking');
        }
        if (value == 2) {
            location.replace('/ranking-spo');
        }
    });
});
